import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { components } from '@glowforge/ui-common';
import { machinePropType } from 'app/selectors/machines';

import './machine-checkbox-group.less';

const { MachineBadge, Button, Checkbox } = components;

/**
 * @deprecated Replaced by MachineAccessField {@link MachineAccessField} using feature flag
 * 'USER_ROLE_MANAGEMENT'. See {@link UserInviteForm}. This component will be removed by APP-3613.
 * TODO: Above is not quite correct -- it seems likely we're keeping both forms that this
 * component is part of on the user settings page since one will be a subscriber feature.
 */
const MachineCheckboxGroup = (props) => {
  const input = props.input;
  const grants = props.grants;

  const machineNames = _.mapValues(_.keyBy(props.options, 'serial'), 'machineName');

  // The newer version of this component manages a list of machine objects
  // instead of just serials. readValue/writeValue transform between the old
  // style and new style so the components can be switched out with a feature
  // flag.
  const readValue = rawValue => _.map(rawValue, m => m.serial);

  // All users are managers under the legacy system, so use that as the default.
  const writeValue = internalValue =>
    _.map(internalValue, s => ({ serial: s, machineName: machineNames[s], roles: ['manager'], grants }));

  const selectAll = () => {
    const newValue = _.map(props.options, m => m.serial);
    input.onChange(writeValue(newValue));
  };

  const removeAll = () => input.onChange([]);

  const list = _.map(props.options, (machine, index) => {
    const onChange = (value) => {
      const newValue = [...readValue(input.value)];
      if (value) {
        newValue.push(machine.serial);
      } else {
        newValue.splice(newValue.indexOf(machine.serial), 1);
      }

      return input.onChange(writeValue(newValue));
    };

    return (
      <tr key={index}>
        <td className='toggle'>
          <Checkbox
            {...input}
            value={_.includes(readValue(input.value), machine.serial)}
            className='machine'
            name={machine.serial}
            onChange={onChange} />
        </td>
        <td className='machineName'>
          {machine.machineName} <MachineBadge model={machine.model} />
        </td>
        <td className='ownerName'>{machine.isOwner ? 'You' : machine.ownerName}</td>
      </tr>
    );
  });

  let errorMessage;
  if (!_.get(props.meta, 'valid')
    && (_.get(props.meta, 'dirty') || _.get(props.meta, 'touched'))) {
    errorMessage = <span className='errorMessage'> - {_.get(props.meta, 'error')}</span>;
  }

  return (
    <div className='MachineCheckboxGroup'>
      <table className='styledTable'>
        <thead>
          <tr className='header label'>
            <th className='toggle'>
              <div>
                <Button type='text' onClick={selectAll}>All</Button>
                <span className='divider'>/</span>
                <Button type='text' onClick={removeAll}>None</Button>
              </div>
            </th>
            <th>Printer {errorMessage}</th>
            <th>Owner</th>
          </tr>
        </thead>
        <tbody>{list}</tbody>
      </table>
    </div>
  );
};

MachineCheckboxGroup.propTypes = {
  grants: PropTypes.arrayOf(PropTypes.string),
  input: PropTypes.shape({ onChange: PropTypes.func }).isRequired,
  meta: PropTypes.shape({
    valid: PropTypes.bool.isRequired,
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape(machinePropType)).isRequired,
};

MachineCheckboxGroup.defaultProps = {
  grants: [],
};

export default MachineCheckboxGroup;



// WEBPACK FOOTER //
// ./app/components/settings/machine-checkbox-group.jsx